"use client";

import { useEffect, useRef } from "react";
import { logClientError } from "@/lib/utils/error-logger-client";
import { captureComponentError } from "@/lib/error-reporting/client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const capturedRef = useRef(false);

  useEffect(() => {
    logClientError("ErrorBoundary.auth", error);

    if (!capturedRef.current) {
      capturedRef.current = true;
      captureComponentError(error, undefined, {
        area: 'auth',
        digest: (error as Error & { digest?: string }).digest,
      }).catch(() => {});
    }
  }, [error]);

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center p-4">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
        Something went wrong
      </h2>
      <button
        onClick={reset}
        className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-500/90"
      >
        Try again
      </button>
    </div>
  );
}
